import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-email-preview',
  template: `<div [innerHTML]="html | safeHtml:'html'"></div>`,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class EmailPreviewComponent {
  @Input() html: string = '';
}